import superFetch from "../../../utils/superFetch"
export const getTrips = async ( page, perPage, status , fromDate , toDate ) => {
   
    let endpoint = "/api/send/trips?"
    if (page) {
        endpoint += `page=${page}&`
    }
    if (perPage) {
        endpoint += `perPage=${perPage}&`
    }
    if (status) {
        endpoint += `status=${status}&`
    }

    if (fromDate) {
        endpoint += `fromDate=${fromDate}&`
    }

    if (toDate) {
        endpoint += `toDate=${toDate}`
    }
    let resposne = await superFetch(endpoint, "get")

    return resposne.data
}

export const getTripDetail = async ( tripid) => {
    let endpoint = `/api/send/trips/${tripid}`
    
    let reponse = await superFetch(endpoint, "get")

    return reponse.data
}

export const downloadPdf = async (startTime, endTime) => {
    let endpoint = `/api/send/trips/dowload/pdf?startTime=${startTime}&endTime=${endTime}`

    let reponse = await fetch(endpoint, {method:"get"})

    

    reponse.blob().then(blob => download(blob, "HastaLavista.pdf"))

    return reponse
}

export const cancelBooking = async (jobId, reason, otherCancellationReason) => {
    let response = await superFetch("/api/send/cancel", "post", {
        "jobId" : jobId ,
        "reason" : reason === 'Others' ? otherCancellationReason : reason ,
    })
    return response
}

export const downloadCsv = async (startTime, endTime) => {

}

function download(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

export const getTopicsByJobIdApi = async (jobId) => {
    let endpoint = `/api/send/help?jobId=${jobId}`
    let response = await superFetch(endpoint, "get")
    return response.data
}

export const createTopicByJobId = async (data) => {
    let endpoint = `/api/send/help/ticket`
    let requestBody = {
            "operatingSystemVersion": "web",
            "phoneBrandModel": "web",
            "countryCode":"sg",
            ...data
    }
    
    let response = await superFetch(endpoint, "post", requestBody)
    return response.data
}
